export const ORG_TYPE = {
  DISTRICT: 'district',
  DISTRICT_GROUP: 'district-group',
}

export const ORG_TYPE_LABEL = {
  [ORG_TYPE.DISTRICT_GROUP]: 'District Group',
}
